import React, { ReactNode } from 'react';

import FormFieldLabel from './FormFieldLabel';
import { IFormFieldProps } from './models';
import { useFormField } from './useFormField';

interface IProps extends IFormFieldProps {
  children: ReactNode | ReactNode[];
}

function FormSelectField({ name, label, optional, children, size = 50 }: IProps) {
  const { id, fieldProps, inputProps } = useFormField(name, size);

  return (
    <div {...fieldProps}>
      {label && (
        <FormFieldLabel htmlFor={id} optional={optional}>
          {label}
        </FormFieldLabel>
      )}
      <select {...inputProps} className={`${inputProps.className} modFormField__input--select`}>
        {children}
      </select>
    </div>
  );
}

export default FormSelectField;
